import { render, staticRenderFns } from "./TransmittedReports.vue?vue&type=template&id=e58676b8&"
import script from "./TransmittedReports.vue?vue&type=script&lang=js&"
export * from "./TransmittedReports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports